import api from "./client";

export function getFacilities() {
  return api.get("/facilities");
}

export function getMyAttorneyAccess() {
  return api.get("/attorney/access");
}

export function requestAttorneyAccess(facilityId) {
  return api.post("/attorney/access/request", {
    facility_id: facilityId,
  });
}

export function getAdminAttorneyAccess() {
  return api.get("/admin/attorney-access");
}

export function approveAttorneyAccess(id) {
  return api.post(`/admin/attorney-access/${id}/approve`);
}

export function rejectAttorneyAccess(id, reason) {
  return api.post(`/admin/attorney-access/${id}/reject`, { reason });
}

export function revokeAttorneyAccess(id, reason) {
  return api.post(`/admin/attorney-access/${id}/revoke`, { reason });
}
